var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_645_9606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4485 4.58591C11.3733 4.35348 11.1672 4.1884 10.9233 4.16642L7.6103 3.8656L6.30026 0.79932C6.20367 0.574601 5.98368 0.429138 5.73925 0.429138C5.49483 0.429138 5.27484 0.574601 5.17825 0.799845L3.86821 3.8656L0.554701 4.16642C0.311242 4.18893 0.105615 4.35348 0.0300369 4.58591C-0.0455407 4.81833 0.0242569 5.07326 0.208428 5.23396L2.71265 7.43018L1.97421 10.683C1.92018 10.9222 2.01301 11.1694 2.21145 11.3128C2.31812 11.3899 2.44292 11.4291 2.56876 11.4291C2.67727 11.4291 2.7849 11.3999 2.88149 11.3421L5.73925 9.6341L8.59597 11.3421C8.80501 11.4678 9.06852 11.4564 9.26653 11.3128C9.46506 11.169 9.55781 10.9216 9.50377 10.683L8.76534 7.43018L11.2696 5.2344C11.4537 5.07326 11.524 4.81877 11.4485 4.58591Z",
    fill: "#FFC700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_645_9606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.12802ad620269dcf44e3ae26a631c554.svg";
export { ForwardRef as ReactComponent };